import React from "react";
import { Box, Accordion, AccordionSummary, Link, AccordionDetails } from "@mui/material";
function ErrorUnstyled({ error }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      position: "absolute",
      left: "0",
      top: "0",
      bottom: "0",
      right: "0"
    },
    /* @__PURE__ */ React.createElement(Box, null, "Something went wrong. Please contact support team."),
    /* @__PURE__ */ React.createElement("br", null),
    /* @__PURE__ */ React.createElement(Accordion, { style: { width: "50%" } }, /* @__PURE__ */ React.createElement(AccordionSummary, null, /* @__PURE__ */ React.createElement(Link, { style: { textAlign: "center", width: "100%" } }, "Check error details")), /* @__PURE__ */ React.createElement(AccordionDetails, null, /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Box, null, error?.message), /* @__PURE__ */ React.createElement(Box, null, error?.stack))))
  );
}
export {
  ErrorUnstyled
};
//# sourceMappingURL=ErrorUnstyled.js.map
